// import Swiper JS
import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";

/* Swipers */
// Single product Swiper
new Swiper(".single-product-swiper", {
	modules: [Navigation, Pagination],
	loop: true,
	draggable: true,
	pagination: {
		el: ".swiper-pagination.single-product-swiper-pagination",
		dynamicBullets: true,
	},

	rewind: true,
	slidesPerView: 1,
	spaceBetween: 20,
	centeredSlides: true,

	navigation: {
		nextEl: ".swiper-button-next.single-product-swiper-next",
		prevEl: ".swiper-button-prev.single-product-swiper-prev",
	},
});

// Product page image swiper
new Swiper(".product-image-swiper", {
	// loop: true,
	modules: [Navigation, Pagination],
	draggable: true,
	rewind: true,
	slidesPerView: 1,
	spaceBetween: 20,
	centeredSlides: true,
	pagination: {
		el: ".swiper-pagination.product-image-pagination",
		clickable: true,
	},
	navigation: {
		nextEl: ".swiper-button-next.product-image-next",
		prevEl: ".swiper-button-prev.product-image-prev",
	},
});

new Swiper(".swiper-auto-width", {
	slidesPerView: "auto",
	spaceBetween: 20,
	draggable: true,
});

document.querySelectorAll(".swiper-basic").forEach((element) => {
	new Swiper(element, {
		// loop: true,
		modules: [Navigation, Pagination],
		draggable: true,
		rewind: true,
		slidesPerView: element.dataset.minimumSlidesPerView || 1,
		spaceBetween: 20,
		centerInsufficientSlides: true,
		pagination: {
			el: ".swiper-pagination.swiper-basic-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: ".swiper-button-next.swiper-basic-next",
			prevEl: ".swiper-button-prev.swiper-basic-prev",
		},
		breakpoints: {
			576: {
				slidesPerView: 2,
			},
			// when window width is >= 640px
			768: {
				slidesPerView: 4,
			},
		},
	});
});

const singleSwipers = document.querySelectorAll(".swiper-loveli-single");

singleSwipers.forEach((swiper, index) => {
	swiper.classList.add(`swiper-single-${index}`);

	const config = {
		// slideToClickedSlide: true,
		// centerInsufficientSlides: true,
		modules: [Navigation, Pagination, Autoplay],
		draggable: true,
		autoplay: true,
		delay: 500,
		rewind: true,
		slidesPerView: 1,
		spaceBetween: 20,
		centeredSlides: true,
		loop: true,
		pauseOnMouseEnter: true,

		navigation: {
			nextEl: `.swiper-single-${index} .swiper-button-next.swiper-single-next`,
			prevEl: `.swiper-single-${index} .swiper-button-prev.swiper-basic-prev`,
		},
	};

	new Swiper(`.swiper-single-${index}`, config);
});

const fadeSwipers = document.querySelectorAll(".swiper-loveli-fade");

fadeSwipers.forEach((swiper, index) => {
	swiper.classList.add(`swiper-fade-${index}`);
	const config = {
		// slideToClickedSlide: true,
		// centerInsufficientSlides: true,
		modules: [Autoplay, EffectFade],
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		autoplay: true,
		delay: 750,
		// loop: true,
		// rewind: true,
	};

	new Swiper(`.swiper-fade-${index}`, config);
});
